import ConsentManagement from "shared/consentManagement/consent";
import { useGetApiData, usePostApiData } from "shared/datalayer";
import PublicApi from "shared/enums/PublicApi";
import { ApiCaptchaResponse } from "shared/types/ApiCaptchaResponse";
import { ApiGDPRConsentRequest } from "shared/types/ApiGDPRConsentRequest";
import { ApiGDPRConsentResponse } from "shared/types/ApiGDPRConsentResponse";
import { getEnvironmentInfo } from "shared/utils/config";
import { AppType, MY_EXPERIENCE } from "shared/utils/enums";

export function useRecordConstent() {
  return usePostApiData<ApiCaptchaResponse, ApiGDPRConsentRequest>(PublicApi.LOG_CONSENT);
}

function getAppTypeForApi() {
  const appType = getEnvironmentInfo().appType;
  if (appType === AppType.MYEXPERIENCE) {
    return MY_EXPERIENCE;
  }
  return appType;
}

export function useGetBannerCopy() {
  const regKey = ConsentManagement.getConsentCopyKey();
  return useGetApiData<ApiGDPRConsentResponse>(
    PublicApi.GET_CONSENT_COPY,
    { params: { regKey, appType: getAppTypeForApi() } },
    {
      hideLoader: true,
      enabled: Boolean(regKey),
      initialData: {
        gdprConfigMetadata: { manager: null, copy: null, loadType: null, script: null },
        gdprConsentEnabled: true,
        gtmKey: "",
        unknown: Boolean(regKey) ? true : false
      } as any
    }
  );
}
